module.exports = __webpack_public_path__ + "img/hcdl_gallery7.d73b31ab.jpg";